export default __webpack_public_path__ + "static/404-7b9f6f43fa512e94d01518bc7905b6ff.png";